import { render, staticRenderFns } from "./product_qr.1688.vue?vue&type=template&id=8b3f55d6&scoped=true"
import script from "./product_qr.1688.vue?vue&type=script&lang=js"
export * from "./product_qr.1688.vue?vue&type=script&lang=js"
import style0 from "./product_qr.1688.vue?vue&type=style&index=0&id=8b3f55d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3f55d6",
  null
  
)

export default component.exports